import store from '@store/index'
import Vue from "vue";
import { userUsesNewUiEligible } from '@utils/userUsesNewUiEligible'

function needsGoogleConnect(user) {
  if (!user || !user.business) return false;
  const instaOnly = user.business.is_insta_stream && !user.business.is_social_fusion && !user.business.is_tap_engine && !user.business.is_social_review && !user.business.is_text_requester && !user.business.is_reply_engine;
  const zensocialOnly = user.business.is_zensocial;
  if (instaOnly || zensocialOnly) return false;
  const noLocation = user.location == null;
  const noGoogleAccounts = !user.google_accounts || !user.google_accounts.length;
  return noLocation || noGoogleAccounts;
}

function businessUsesNewUi(user) {
  return userUsesNewUiEligible(user)
}

function isSettingsRoute(name) {
  return name === 'business.settings' || name === 'new-business.settings';
}

function settingsRouteFor(user) {
  return businessUsesNewUi(user) ? 'new-business.settings' : 'business.settings';
}

/** Map new-business.* route suffix -> legacy business.* route name (mini-app / non–premium RepuAgency users). */
function legacyBusinessNameForNewSuffix(suffix) {
  const map = {
    dashboard: 'business.dashboard',
    reviews: 'business.reviews',
    employees: 'business.employees',
    settings: 'business.settings',
    'social-posts': 'business.social-posts',
    'instagram-widget': 'business.instagram-widget',
    // Legacy users: send to in-app Review Gate admin (not dashboard — they lose landing-page parity otherwise).
    'review-landing-page': 'business.review-gate',
    'review-surge': 'business.review-contact-series',
    'review-sequence': 'business.review-contact-series',
    'review-images': 'business.review-images',
    'review-image-editor': 'business.review-image-editor',
    'request-contacts': 'business.request-contacts',
    'request-personalized-image': 'business.image-editor-dashboard',
    'request-review-widget': 'business.review-widgets',
  };
  return map[suffix] || 'business.dashboard';
}

function BusinessGuard(to, from, next) {
  let user = store.getters['auth/user'];
  if (!user) {
    next({ name: 'login' })
  } else if (!user.subscribed && to.name !== 'business.contact-agency') {
 next({ name: 'business.contact-agency' });
  } else if (user.role !== 'Business') {
    next('/')
  } else if (to.name && String(to.name).startsWith('new-business.') && !businessUsesNewUi(user)) {
    const suffix = to.name.replace(/^new-business\./, '')
    const legacyName = legacyBusinessNameForNewSuffix(suffix)
    const route = { name: legacyName, query: to.query, hash: to.hash }
    if (legacyName === 'business.review-image-editor' && to.params && to.params.platform) {
      route.params = { platform: to.params.platform }
    }
    next(route)
  } else if (
    businessUsesNewUi(user) &&
    to.name &&
    String(to.name).startsWith('business.') &&
    to.name !== 'business.process-review' &&
    to.name !== 'business.image-editor' &&
    to.name !== 'business.image-editor-dashboard'
  ) {
    // Premium RepuAgency: keep /new-business/* routes
    const suffix = to.name.replace(/^business\./, '')
    const newBusinessRouteNames = [
      'dashboard', 'reviews', 'employees', 'settings', 'social-posts', 'instagram-widget',
      'review-landing-page', 'review-surge', 'review-sequence', 'review-images', 'review-image-editor',
      'request-contacts', 'request-personalized-image', 'request-review-widget',
    ]
    const newName = newBusinessRouteNames.includes(suffix) ? 'new-business.' + suffix : 'new-business.dashboard'
    const forward = { name: newName, query: to.query, hash: to.hash }
    if (newName === 'new-business.review-image-editor' && to.params && to.params.platform) {
      forward.params = { platform: to.params.platform }
    }
    next(forward)
  } else if (needsGoogleConnect(user) && !isSettingsRoute(to.name) && to.name !== 'business.contact-agency') {
    Vue.$toast.open({
      message: "Please connect your Google account in Settings before using the rest of the software.",
      type: 'error',
      duration: 5000,
    });
    next({ name: settingsRouteFor(user) });
  } else if (user.business?.is_social_fusion && !user.business?.is_insta_stream && !user.business.is_tap_engine && !user.business.is_social_review && !user.business.is_text_requester && !user.business.is_reply_engine && to.name === 'business.dashboard') {
    next({ name: 'business.social-posts' });
  } else if (user.business?.is_insta_stream && !user.business?.is_social_fusion && !user.business.is_tap_engine && !user.business.is_social_review && !user.business.is_text_requester && !user.business.is_reply_engine && to.name === 'business.dashboard') {
    next({ name: 'business.instagram-widget' });
  } else {
    next()
  }
}

export default BusinessGuard
